import React from "react";
import { Artwork } from "../../types";

interface ArtworkDetailsProps {
  artwork: Artwork | null;
  firstParagraphRef: React.RefObject<HTMLDivElement>;
}

const ArtworkDetails: React.FC<ArtworkDetailsProps> = ({
  artwork,
  firstParagraphRef,
}) => {
  if (!artwork) return null;

  const { title, author, details, collection, tags } = artwork;

  const detailItems = [
    { label: "Collectie", value: collection?.name },
    { label: "Soort", value: details.type },
    { label: "Materiaal", value: details.material },
    { label: "Afmetingen", value: details.dimension },
    { label: "Locatie", value: details.location },
  ].filter((item) => item.value);

  return (
    <div className="min-h-screen w-full bg-darkBeige sticky top-0 z-20 overflow-hidden">
      <div className="text-white container mx-auto w-full px-4 md:w-1/2 py-16">
        <h1 className="text-3xl leading-none">{title}</h1>
        <h2 className="text-lg mb-10">
          {author.name}{" "}
          <time className="font-normal">{details.start_year}</time>
        </h2>
        {/* Empty div to serve as the scroll target */}
        <div ref={firstParagraphRef}></div>
        <div
          className="text-base mb-10 first-paragraph-only"
          dangerouslySetInnerHTML={{ __html: details.description }}
        ></div>
        <ul className="text-sm">
          {detailItems.map((item, index) => (
            <li key={index} className="mb-4 flex">
              <div>
                <p className="font-bold">{item.label}</p>
                <p>{item.value}</p>
              </div>
            </li>
          ))}
          {tags?.length > 0 && (
            <li className="mb-4 flex w-full">
              <div className="font-bold">
                <p className="text-sm mb-2">Onderwerpen</p>
                <div className="flex flex-wrap">
                  {tags.map((tag) => (
                    <span
                      key={tag.id}
                      className="inline-flex items-center justify-center mb-2 px-4 py-2 mr-2 text-sm text-white bg-opacity-10 rounded-full border-2 border-white/50"
                    >
                      {tag.name.en}
                    </span>
                  ))}
                </div>
              </div>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ArtworkDetails;
